module.exports = __webpack_public_path__ + "img/online.5b26a9e3.png";